import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    boxSwitch: {
      marginTop: -theme.spacing(3),
      paddingBottom: theme.spacing(10),
    },
    titleText: {
      '& .MuiFormControlLabel-label': {
        ...CommonFonts.darkFont18,
      },
    },
    descriptionText: {
      ...CommonFonts.grayFont14,
    },
  })
);

export default useStyles;
